import { AppError } from '@vk-hr-tek/core/error';

import {
  Collection,
  EventTypesList,
  GetCollectionsEventTypesResponseCollection,
} from '@app/gen/event-type';

import { EventItemType } from '../types';

export interface ProcessCatalogState {
  collections: {
    status: 'idle' | 'loading' | 'complete' | 'failed';
    error: AppError | null;
    items: Collection[];
  };
  eventTypes: {
    status: 'idle' | 'loading' | 'complete' | 'failed';
    error: AppError | null;
    collection: GetCollectionsEventTypesResponseCollection | null;
    items: EventTypesList[];
    selectedEventType: EventItemType | null;
  };
}

export const initialState: ProcessCatalogState = {
  collections: {
    status: 'idle',
    error: null,
    items: [],
  },
  eventTypes: {
    status: 'idle',
    error: null,
    collection: null,
    items: [],
    selectedEventType: null,
  },
};
